module.exports = __webpack_public_path__ + "static/media/phone-number-CTR.c543d68e.png";